import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { IIdName } from '@nimbus-library/features/shared/models/interfaces';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { MediaPlayerMode } from '@nimbus-library/features/shared/components/material/input-media-player/input-media-player.component';
import { AudioService } from '../../../services/audio.service';

@Component({
  standalone: false,
  selector: 'app-settings-notifications-tab',
  templateUrl: './settings-notifications-tab.component.html',
  styleUrls: ['./settings-notifications-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsNotificationsTabComponent implements OnInit {
  @Input()
  public formGroupName: string;
  public form: FormGroup;

  public optionsAudioFiles: IIdName[];

  public TranslationKeys = TranslationKeys;
  public readonly MediaPlayerMode = MediaPlayerMode;

  public constructor(
    private rootFormGroup: FormGroupDirective,
    public readonly audioService: AudioService,
  ) {}

  public ngOnInit(): void {
    this.optionsAudioFiles = this.audioService.getAudioFiles();
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
  }
}
